import $ from 'jquery';
import '../vendor/jquery-ui.min.js';

const execReference = e => {
    // Reference main function

    let active = 0;

    let highest = 0;
    let highestI = '';

    let hasClicked = false;

    $(e).find('.sectionBody').each((o, l) => {
        if($(l).outerHeight() > highest) {
            highest = $(l).outerHeight();
            highestI = l;
        }
    });

    $(e).find('.referenceColMid').css('height', $(highestI).outerHeight());

    const setItems = (e, y, q) => {
    
        if(hasClicked === true) {
            return;
        }

        let lastActive = active;

        if(q === 0 || q === 1 || q === 2) {
            active = q;
        }

        if(y === -1 && active === 0) {
            active = 2;
        } else if (y === 1 && active === 2) {
            active = 0;
        } else {
            active += y;
        }
        
        $(e).find('.sectionBody').each((i, s) => {
            if(i === active) {
                if(y === -1) {
                    $(s).show('slide', {direction: 'left'}, 500);
                } else if(y === 1) {
                    $(s).show("slide", { direction: "right" }, 500);
                } else {
                    if(q === 0) {
                        $(s).show('slide', {direction: 'left'}, 500);
                    } else if (q === 1) {
                        if(lastActive === 0) {
                            $(s).show('slide', {direction: 'right'}, 500);
                        } else if (lastActive === 2) {
                            $(s).show('slide', {direction: 'left'}, 500);
                        }
                    } else if (q === 2) {
                        $(s).show('slide', {direction: 'right'}, 500);
                    } else {
                        $(s).show();
                    }
                }
            } else {
                if(y === -1) {
                    $(s).hide("slide", { direction: "right" }, 500);
                } else if(y === 1) {
                    $(s).hide("slide", { direction: "left" }, 500);
                } else {
                    if(q === 0) {
                        $(s).hide('slide', {direction: 'right'}, 500);
                    } else if (q === 1) {
                        if(lastActive === 0) {
                            $(s).hide('slide', {direction: 'left'}, 500);
                        } else if (lastActive === 2) {
                            $(s).hide('slide', {direction: 'right'}, 500);
                        }
                    } else if (q === 2) {
                        $(s).hide('slide', {direction: 'left'}, 500);
                    } else {
                        $(s).hide();
                    }
                }
            }
        });
    
        $(e).find('.referenceIndexBtns > img').each((i, x) => {
            if(i === active) {
                $(x).addClass('indexActive');
            } else {
                $(x).removeClass('indexActive');
            }
        });

        hasClicked = true;
        setTimeout(() =>  {
            hasClicked = false;
        }, 500);
    };

    setItems(e, 0);

    $(e).find('.referenceColLeft > img').click(() => {
        setItems(e, -1);
    });

    $(e).find('.referenceColRight > img').click(() => {
        setItems(e, 1);
    });

    let iBtns = $(e).find('.referenceIndexBtns > img');

    $(iBtns[0]).click(() => {
        setItems(e, 0, 0);
    });

    $(iBtns[1]).click(() => {
        setItems(e, 0, 1);
    });

    $(iBtns[2]).click(() => {
        setItems(e, 0, 2);
    });

    setInterval(() => {
        if(active === 2) {
            setItems(e, 0, 0);
        } else {
            setItems(e, 0, active + 1);
        }
    }, 10000);
};

$(document).ready(() => {
    // Check if there is a reference block on the page
    if($('.referenceContainer').length) {
        // Run main function for all blocks on page
        setTimeout(() => {
            $('.referenceContainer').each((i, e) => {
                execReference(e);
            });
        }, 125);
    }
});